import { getStore } from '../store/store';

/**
 * Check if permission present at a given index is of distinguished user or not.
 * @param permissionIndex The index of permission
 * @return boolean
 */
function isDistinguishedPermissionUser(permissionIndex: number): boolean {
    const permission = getStore().permissions[permissionIndex];
    return !!permission.UserId?.DistinguishedUser;
}

export default isDistinguishedPermissionUser;
